(() => {
  if (window.lkVehicleFinderLoaded) return;
  window.lkVehicleFinderLoaded = true;

  const lkInstances = new Map();
  let lkScrollLocks = 0;
  let lkOwnsScrollLock = false;

  function lkLockScroll() {
    if (lkScrollLocks === 0) {
      lkOwnsScrollLock =
        !document.documentElement.classList.contains(
          'lk-finder-open'
        );

      if (lkOwnsScrollLock) {
        document.documentElement.classList.add(
          'lk-finder-open'
        );
      }
    }

    lkScrollLocks += 1;
  }

  function lkUnlockScroll() {
    lkScrollLocks = Math.max(0, lkScrollLocks - 1);

    if (lkScrollLocks === 0 && lkOwnsScrollLock) {
      document.documentElement.classList.remove(
        'lk-finder-open'
      );
      lkOwnsScrollLock = false;
    }
  }

  function lkInitDialog(lkDialog) {
    if (lkInstances.has(lkDialog)) return;

    const lkClose = lkDialog.querySelector(
      '[data-lk-finder-close]'
    );

    const lkControls = lkDialog.querySelector(
      '.lk-ymm-controls'
    );

    if (!lkClose || !lkControls) return;

    const lkAbort = new AbortController();
    const lkOptions = { signal: lkAbort.signal };

    let lkOpener = null;
    let lkLocked = false;

    function lkUpdateButton() {
      const lkLabel = lkDialog.dataset.lkButtonLabel;
      if (!lkLabel) return;

      const lkButton = lkControls.querySelector(
        '#ymm_search'
      );

      if (!lkButton) return;

      if (lkButton.tagName === 'INPUT') {
        if (lkButton.value !== lkLabel) {
          lkButton.value = lkLabel;
        }
      } else if (lkButton.textContent !== lkLabel) {
        lkButton.textContent = lkLabel;
      }
    }

    // The app replaces controls after vehicle selections.
    // Observe only that small subtree, not the document.
    const lkObserver = new MutationObserver(
      lkUpdateButton
    );

    lkObserver.observe(lkControls, {
      childList: true,
      subtree: true
    });

    lkUpdateButton();

    function lkReleaseScroll() {
      if (!lkLocked) return;
      lkLocked = false;
      lkUnlockScroll();
    }

    function lkOpen(lkTrigger) {
      if (lkDialog.open) return true;

      if (typeof lkDialog.showModal !== 'function') {
        return false;
      }

      lkUpdateButton();
      lkOpener = lkTrigger;

      try {
        lkDialog.showModal();
      } catch {
        return false;
      }

      lkLockScroll();
      lkLocked = true;
      lkClose.focus({ preventScroll: true });

      return true;
    }

    lkClose.addEventListener(
      'click',
      () => lkDialog.close(),
      lkOptions
    );

    lkDialog.addEventListener(
      'close',
      () => {
        lkReleaseScroll();

        if (lkOpener?.isConnected) {
          lkOpener.focus({ preventScroll: true });
        }
      },
      lkOptions
    );

    lkDialog.addEventListener(
      'click',
      (lkEvent) => {
        if (lkEvent.target !== lkDialog) return;

        const lkRect = lkDialog.getBoundingClientRect();

        if (
          lkEvent.clientX < lkRect.left ||
          lkEvent.clientX > lkRect.right ||
          lkEvent.clientY < lkRect.top ||
          lkEvent.clientY > lkRect.bottom
        ) {
          lkDialog.close();
        }
      },
      lkOptions
    );

    function lkDestroy() {
      lkAbort.abort();
      lkObserver.disconnect();

      if (lkDialog.open) {
        lkDialog.close();
      }

      lkReleaseScroll();
      lkInstances.delete(lkDialog);
    }

    lkInstances.set(lkDialog, {
      lkOpen,
      lkDestroy
    });
  }

  function lkScan(lkRoot = document) {
    if (lkRoot.matches?.('[data-lk-vehicle-finder]')) {
      lkInitDialog(lkRoot);
    }

    lkRoot.querySelectorAll(
      '[data-lk-vehicle-finder]'
    ).forEach(lkInitDialog);
  }

  document.addEventListener('click', (lkEvent) => {
    if (
      lkEvent.defaultPrevented ||
      lkEvent.button !== 0 ||
      lkEvent.metaKey ||
      lkEvent.ctrlKey ||
      lkEvent.shiftKey ||
      lkEvent.altKey ||
      !(lkEvent.target instanceof Element)
    ) {
      return;
    }

    const lkLink = lkEvent.target.closest(
      '.header-subnav-item-link'
    );

    if (
      !lkLink ||
      lkLink.getAttribute('href') !==
        '#lk-vehicle-finder'
    ) {
      return;
    }

    const lkDialog = document.querySelector(
      '[data-lk-vehicle-finder]'
    );

    if (!lkDialog) return;

    lkInitDialog(lkDialog);

    const lkInstance = lkInstances.get(lkDialog);

    if (lkInstance?.lkOpen(lkLink)) {
      lkEvent.preventDefault();
    }
  });

  document.addEventListener(
    'shopify:section:load',
    (lkEvent) => lkScan(lkEvent.target)
  );

  document.addEventListener(
    'shopify:section:unload',
    (lkEvent) => {
      for (const [lkDialog, lkInstance] of lkInstances) {
        if (lkEvent.target.contains(lkDialog)) {
          lkInstance.lkDestroy();
        }
      }
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => lkScan(),
      { once: true }
    );
  } else {
    lkScan();
  }
})();
